import { Card } from "@/components/atoms"

// التفاصيل ظاهرة دائماً بلا طيّ: فيها السيارات المتوافقة، وهي أول ما يبحث عنه الزبون.
export const ProductPageDetails = ({ details }: { details: string }) => {
  if (!details) return null

  return (
    <Card data-testid="product-details-section">
      <h4 className="label-lg px-2 py-4">تفاصيل القطعة</h4>
      <div className="px-2 pb-2">
        <div
          className="product-details"
          dangerouslySetInnerHTML={{
            __html: details,
          }}
          data-testid="product-details-content"
        />
      </div>
    </Card>
  )
}
